// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import React from "react";
// import { NavLink } from "react-router-dom";
// import { FontIcon } from "office-ui-fabric-react";
// import ConditionalNavLink from "../common/conditionalNavLink/conditionalNavLink";
// import { strings } from "../../../common/strings";
import HeaderComponent from "../header/header";
// import { Report } from 'powerbi-report-component';
import PowerbiEmbedded from 'react-powerbi';
/**
 * Side bar that remains visible throughout app experience
 * Contains links to editor, settings, export, etc.
 * @param param0 - {
 *      project - IProject
 * }
 */
const DashBoardpb = (props) => {
    console.log(props);
    return(
        <>
        <HeaderComponent
            history={props.history}
            match={props.match}
            location={props.location} />
        {/* <div className="container-fluid animated fadeIn"> */}
        <PowerbiEmbedded
              
              

       id="b920ac93-c596-492e-8c38-3483546e8994"
       embedUrl="https://app.powerbi.com/view?r=eyJrIjoiODhiYzcxMTMtMmM4MS00ZDAxLWE1OWUtZTZkMGE2NjgxYjlkIiwidCI6IjJiNmM2MDBmLWI2Y2ItNDMyOS1hZjNiLTFiMzJjNjJjNDQwZiJ9"
       //embedUrl="https://app.powerbi.com/view?r=eyJrIjoiZmYxOTA3NjMtYjYwZC00NjMxLWIxZDQtMTkzN2Q0OWFmNWJlIiwidCI6IjJiNmM2MDBmLWI2Y2ItNDMyOS1hZjNiLTFiMzJjNjJjNDQwZiJ9&pageName=ReportSectionfb9717b0da386e03a12a"
     //embedUrl = "https://app.powerbi.com/view?r=eyJrIjoiMTNhODRmNmUtMzQ4OC00YzJkLWI4NTUtMTM3MWRhNWM1OGFkIiwidCI6IjJiNmM2MDBmLWI2Y2ItNDMyOS1hZjNiLTFiMzJjNjJjNDQwZiJ9"
     accessToken="2b6c600f-b6cb-4329-af3b-1b32c62c440f"
        
                filterPaneEnabled={false}
                navContentPaneEnabled={false}
                settings={{
                    // any settings including localeSettings
                }}
                height='90vh'
                />
  

            {/* </div> */}
        </>
    )};

export default DashBoardpb;
